import { IGoalsAndOperationalPlans } from '@Domains/Progress';
import { progressTargetGroupAndPlanData } from '../../utils';
import ProgressBarDetails from './ProgressBarDetails';

type GoalAndOperationalPlansProgressProps = {
  goalsAndOperationalPlans: IGoalsAndOperationalPlans;
  reportId?: number;
  isPublished: boolean;
};

const GoalAndOperationalPlansProgress = ({
  goalsAndOperationalPlans,
  reportId,
  isPublished,
}: GoalAndOperationalPlansProgressProps) => {
  return (
    <ProgressBarDetails
      title={'แผนการเพิ่มมูลค่าองค์กร และการบริหารความเสี่ยง'}
      progressData={progressTargetGroupAndPlanData(goalsAndOperationalPlans)}
      id={reportId}
      isPublished={isPublished}
    />
  );
};

export default GoalAndOperationalPlansProgress;
